/**
 * @Date: 2020-06-15 11:49
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 */
import Main from '@/components/Layout/Layout'
import SubMain from '@/views/Main'

export default {
  sort: 4,
  routers: [
    {
      path: '/Business',
      name: 'business',
      component: Main,
      meta: {
        isHideInMenu: false,
        isCache: false,
        icon: 'alert',
        title: '业务管理'
      },
      redirect: '/Business/SubAccount/Bank',
      children: [
        // {
        // path: '/Business/Receive',
        // name: '',
        // component: SubMain,
        // meta: {
        //   isHideInMenu: false,
        //   isCache: false,
        //   icon: 'solution',
        //   title: '收款管理'
        // },
        // redirect: '/Business/SubAccount/Bank',
        // children: [
        //   {
        //     path: '/Business/Receive/Platform',
        //     name: '',
        //     meta: {
        //       isHideInMenu: false,
        //       isCache: false,
        //       icon: '',
        //       title: '收款平台管理'
        //     },
        //     component: () => import('@/views/Business/Receive/Platform/Platform.vue')
        //   },
        //   {
        //     path: '/Business/Receive/Bank',
        //     name: '',
        //     meta: {
        //       isHideInMenu: false,
        //       isCache: false,
        //       icon: '',
        //       title: '收款银行管理'
        //     },
        //     component: () => import('@/views/Business/Receive/Bank/Bank.vue')
        //   },
        //   {
        //     path: '/Business/Receive/BankCardNumber',
        //     name: '',
        //     meta: {
        //       isHideInMenu: false,
        //       isCache: false,
        //       icon: '',
        //       title: '收款银行号段管理'
        //     },
        //     component: () => import('@/views/Business/Receive/BankCardNumber/BankCardNumber.vue')
        //   }
        // ]
        // },
        {
          path: '/Business/SubAccount',
          name: '',
          component: SubMain,
          meta: {
            isHideInMenu: false,
            isCache: false,
            icon: 'solution',
            title: '子账户管理'
          },
          redirect: '/Business/SubAccount/Bank',
          children: [
            {
              path: '/Business/SubAccount/Bank',
              name: '',
              meta: {
                isHideInMenu: false,
                isCache: false,
                icon: '',
                title: '银行管理'
              },
              component: () => import('@/views/Business/SubAccount/Bank/Bank.vue')
            }
          ]
        },
        {
          path: '/Business/Swap',
          name: '',
          component: SubMain,
          meta: {
            isHideInMenu: false,
            isCache: false,
            icon: 'solution',
            title: '换汇管理'
          },
          redirect: '/Business/Swap/Manage',
          children: [
            {
              path: '/Business/Swap/Manage',
              name: '',
              meta: {
                isHideInMenu: false,
                isCache: false,
                icon: '',
                title: '汇率请求记录'
              },
              component: () => import('@/views/Business/Swap/SwapManage.vue')
            }
          ]
        }
      ]
    }
  ]
}
